import { useEffect, useRef, useState } from "react";
import { SignIn, useAuth } from "@clerk/clerk-react";
import { authorizeMcp } from "@/services/oauthService";
import loadingMarkUrl from "@/assets/brand/loading-screen-mark.svg";

function Frame({ children }: { children: React.ReactNode }) {
  return (
    <main className="flex min-h-screen w-screen items-center justify-center bg-[#111318] px-6 text-[#F6F2EA]">
      <div className="flex max-w-md flex-col items-center gap-4 text-center">{children}</div>
    </main>
  );
}

export default function McpAuthorize() {
  const { isSignedIn, getToken } = useAuth();
  const started = useRef(false);
  const [error, setError] = useState<string | null>(null);
  const returnURL = `${window.location.pathname}${window.location.search}`;

  useEffect(() => {
    if (!isSignedIn || started.current) return;
    started.current = true;
    authorizeMcp(getToken, window.location.search)
      .then((redirectTo) => window.location.replace(redirectTo))
      .catch((reason: unknown) => {
        setError(reason instanceof Error ? reason.message : "OAuth authorization failed");
      });
  }, [getToken, isSignedIn]);

  if (!isSignedIn) {
    return (
      <Frame>
        <SignIn routing="virtual" forceRedirectUrl={returnURL} />
      </Frame>
    );
  }

  if (error) {
    return (
      <Frame>
        <h1 className="text-xl font-semibold">Could not connect Codex</h1>
        <p role="alert" className="text-sm text-red-300">{error}</p>
      </Frame>
    );
  }

  return (
    <Frame>
      <img src={loadingMarkUrl} width={40} height={40} alt="Taitora" draggable={false} />
      <h1 className="text-xl font-semibold">Connecting Codex to Taitora…</h1>
      <p className="text-sm text-zinc-400">You will return to Codex automatically.</p>
    </Frame>
  );
}
